import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';

// bodyRowHeight is 40 by standard but check before use
// headerHeight is 50 as standard but check before use
// 
// This component will take the place of a table while its loading, 
// If you keep the table header height and row height as consistant as possible then this will work nicely.
// There are ways of keeping everything conistant. 
// Check: waste, transations & transfer pages as examples.
export const TableLoading = (props: {
  headerHeight: number,
  bodyRowHeight: number,
  minTableWidth?: number,
}) => {
  const theme = useTheme();

  function getScrollbarSize() {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';

    document.body.appendChild(scrollDiv);
    const scrollbarHeight = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);

    return scrollbarHeight;
  }

  const scrollbarHeight = getScrollbarSize();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isBelowMobileBreakpoint = useMediaQuery(`(max-width:${(props.minTableWidth ?? 0) + 32}px)`);
  const isBelowDesktopBreakpoint = useMediaQuery(`(max-width:${(props.minTableWidth ?? 0) + 365}px)`);

  let scrollBarHeightToUse = 0;
  if (isBelowMobileBreakpoint && isMobile) {
    scrollBarHeightToUse = scrollbarHeight;
  }
  if (isBelowDesktopBreakpoint && !isMobile) {
    scrollBarHeightToUse = scrollbarHeight;
  }

  return <Box sx={{
    borderTop: '1px solid',
    borderColor: theme.palette.custom.gray[200],
  }}>
    <Skeleton
      sx={{
        bgcolor: theme.palette.custom.gray[100],
      }}
      variant='rectangular'
      height={props.headerHeight + (props.bodyRowHeight * 10) + scrollBarHeightToUse} />
  </Box>;
};